import axios from "axios";
import { getUniqueChildCategories, isServer } from "lib/utils";
import config from "config";

const proxyUrl = "/api/proxy";

const nextJSApi = `${proxyUrl}/vsyncapi-v2/account-tags/virtuaalikirkko`;
const accountTagsBaseUrlVsync =
  config.vsyncUrl + "/api/v2/account-tags/virtuaalikirkko";

const accountTagsBaseUrl = isServer() ? accountTagsBaseUrlVsync : nextJSApi;

export const BASE_CATEGORY_SLUG = "virtuaalikirkko";
export const EVENTS_LIMIT_PER_PAGE = 15;

const createSearchParamsFromObject = (params: any) => {
  if (params && Object.keys(params).length > 0) {
    const urlParams = new URLSearchParams(params);
    return "?" + urlParams.toString();
  }
  return "";
};

export const fetchCategories = async (
  category = BASE_CATEGORY_SLUG,
  searchParams = {}
) => {
  let url = `${accountTagsBaseUrl}/categories/${category}`;
  url += createSearchParamsFromObject(searchParams);

  const request = await axios.get(url);

  return request.data;
};

export interface EventSearchParams {
  startDate?: string;
  endDate?: string;
  accountUrls?: string;
  states?: number[];
  search?: string;
  sort?: string[];
  page?: number;
  limit?: number;
}

export const fetchEventsAndCategories = async (search: string) => {
  // Setup output
  const output = {
    categories: [],
    events: [],
  };

  let categoryChildren = [];

  // Search from categories

  const categoriesResponse = await fetchCategories(BASE_CATEGORY_SLUG, {
    include: ["children"],
  });

  categoryChildren = getUniqueChildCategories(categoriesResponse);

  output.categories = categoriesResponse
    .filter((category) => {
      const { account, descriptionParsed } = category;

      if (descriptionParsed) {
        if (
          (descriptionParsed.data.address &&
            descriptionParsed.data.address.toLowerCase().includes(search)) ||
          descriptionParsed.content.toLowerCase().includes(search)
        ) {
          return true;
        }
      }
      return account.name.toLowerCase().includes(search);
    })
    .map((c) => {
      c.children = undefined;
      return c;
    });

  // Populate events
  const events = await fetchEvents(
    categoryChildren.map((cc) => cc.slug),
    {
      search,
    }
  );

  // Disrecard events.hasmore and just return events from the data
  output.events = events.events;
  return output;
};

// export const fetchEventsAndCategories = async (search: string) => {
//   const url = "/api/search?q=" + search;
//   const request = await axios.get(url);
//   return request.data;
// };

export const fetchEvents = async (
  categories: Array<string>,
  searchParams: EventSearchParams
) => {
  const _categories = Array.isArray(categories) ? categories : [categories];
  let url = `${accountTagsBaseUrl}/categories/${_categories.join(",")}/events`;
  url += createSearchParamsFromObject(searchParams);

  const request = await axios.get(url);
  if (request.data.hasMore) {
    request.data.nextPage = searchParams.page ? searchParams.page + 1 : 2;
  }
  return request.data;
};

export const fetchEvent = async (
  accountSlug,
  eventSlug,
  token?: string | undefined
) => {
  let url = isServer()
    ? `${process.env.VIDEOSYNC_URL}/account/${accountSlug}/${eventSlug}/data`
    : `/api/event?account=${accountSlug}&urlName=${eventSlug}`;

  if (token) {
    url += `?authtoken=${token}`;
  }

  const request = await axios.get(url);
  return request.data;
};

export const passwordSignInToEvent = async (
  account: string,
  eventUrl: string,
  eventId: string,
  password: string
) => {
  const params = createSearchParamsFromObject({
    account,
    eventUrl,
    eventId,
  });
  const url = isServer()
    ? `${process.env.VIDEOSYNC_URL}/account/${account}/api/v1/events/${eventId}/password`
    : `/api/event/sign-in${params}`;
  const data = {
    password,
  };

  const request = await axios.post(url, data);
  return request.data;
};
